var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { css } from '@emotion/css';
import { ThemeColor, Theme } from './types';
import { client } from './graphql/client';
import { profileById, profileByAddress, getFollowers, profileByHandle } from './graphql';
import { formatProfilePicture, systemFonts, formatHandleColors, returnIpfsPathOrUrl, formatHandleList, getSubstring } from './utils';
export function Profile(_a) {
    var _b, _c, _d, _e;
    var profileId = _a.profileId, ethereumAddress = _a.ethereumAddress, handle = _a.handle, onClick = _a.onClick, _f = _a.theme, theme = _f === void 0 ? Theme["default"] : _f, _g = _a.containerStyle, containerStyle = _g === void 0 ? profileContainerStyle : _g, hideFollowButton = _a.hideFollowButton;
    var _h = __read(useState(), 2), profile = _h[0], setProfile = _h[1];
    var _j = __read(useState([]), 2), followers = _j[0], setFollowers = _j[1];
    useEffect(function () {
        fetchProfile();
    }, [profileId, handle, ethereumAddress]);
    function onProfilePress() {
        if (onClick) {
            onClick();
        }
        else {
            if (profile) {
                var URI = "https://lenster.xyz/u/".concat(profile.handle);
                window.open(URI, '_blank');
            }
        }
    }
    function fetchFollowers(id) {
        return __awaiter(this, void 0, void 0, function () {
            var data, filteredProfiles, first3, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, client
                                .query(getFollowers, {
                                profileId: id
                            })
                                .toPromise()];
                    case 1:
                        data = (_a.sent()).data;
                        filteredProfiles = data.followers.items.filter(function (p) { return p.wallet.defaultProfile.handle; });
                        filteredProfiles = filteredProfiles.filter(function (p) { return p.wallet.defaultProfile.picture; });
                        filteredProfiles = filteredProfiles.filter(function (p) { return p.wallet.defaultProfile.picture.original; });
                        first3 = JSON.parse(JSON.stringify(filteredProfiles.slice(0, 3)));
                        first3 = first3.map(function (profile) {
                            profile.handle = profile.wallet.defaultProfile.handle;
                            profile.picture = returnIpfsPathOrUrl(profile.wallet.defaultProfile.picture.original.url);
                            return profile;
                        });
                        setFollowers(first3);
                        return [3, 3];
                    case 2:
                        err_1 = _a.sent();
                        console.log('error fetching followers ...', err_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    }
    function fetchProfile() {
        return __awaiter(this, void 0, void 0, function () {
            var data, err_2, data, err_3, data, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!profileId && !ethereumAddress && !handle) {
                            return [2, console.log('please pass in either a Lens profile ID or an Ethereum address')];
                        }
                        if (!handle) return [3, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        handle = handle.toLowerCase();
                        if (!handle.includes('.lens')) {
                            handle = handle + '.lens';
                        }
                        return [4, client
                                .query(profileByHandle, {
                                handle: handle
                            })
                                .toPromise()];
                    case 2:
                        data = (_a.sent()).data;
                        formatProfile(data.profile);
                        fetchFollowers(data.profile.id);
                        return [3, 4];
                    case 3:
                        err_2 = _a.sent();
                        console.log('error fetching profile... ', err_2);
                        return [3, 4];
                    case 4: return [3, 13];
                    case 5:
                        if (!profileId) return [3, 10];
                        _a.label = 6;
                    case 6:
                        _a.trys.push([6, 8, , 9]);
                        return [4, client
                                .query(profileById, {
                                profileId: profileId
                            })
                                .toPromise()];
                    case 7:
                        data = (_a.sent()).data;
                        fetchFollowers(profileId);
                        formatProfile(data.profile);
                        return [3, 9];
                    case 8:
                        err_3 = _a.sent();
                        console.log('error fetching profile... ', err_3);
                        return [3, 9];
                    case 9: return [3, 13];
                    case 10:
                        _a.trys.push([10, 12, , 13]);
                        return [4, client
                                .query(profileByAddress, {
                                address: ethereumAddress
                            })
                                .toPromise()];
                    case 11:
                        data = (_a.sent()).data;
                        fetchFollowers(data.defaultProfile.id);
                        formatProfile(data.defaultProfile);
                        return [3, 13];
                    case 12:
                        err_4 = _a.sent();
                        console.log('error fetching profile... ', err_4);
                        return [3, 13];
                    case 13: return [2];
                }
            });
        });
    }
    function formatProfile(profile) {
        var copy = formatProfilePicture(profile);
        setProfile(copy);
    }
    if (!profile)
        return null;
    return (_jsxs("div", __assign({ style: containerStyle, className: profileContainerClass, onClick: onProfilePress }, { children: [_jsx("div", __assign({ className: headerImageContainerStyle }, { children: _jsxs("div", { children: [((_b = profile.coverPicture) === null || _b === void 0 ? void 0 : _b.__typename) === 'MediaSet' ? (_jsx("div", { style: getHeaderImageStyle((_d = (_c = profile === null || profile === void 0 ? void 0 : profile.coverPicture) === null || _c === void 0 ? void 0 : _c.original) === null || _d === void 0 ? void 0 : _d.url) })) : _jsx("div", { style: getHeaderImageStyle() }), _jsxs("div", { children: [((_e = profile.picture) === null || _e === void 0 ? void 0 : _e.__typename) === 'MediaSet' ? (_jsx("div", __assign({ className: getProfilePictureContainerStyle(theme) }, { children: _jsx("img", { src: profile.picture.original.url, className: profilePictureStyle }) }))) : null, profile.picture === null && (_jsx("div", { className: emptyProfilePictureStyle }))] })] }) })), _jsxs("div", __assign({ className: getProfileInfoContainerStyle(theme) }, { children: [_jsx("div", __assign({ className: getButtonContainerStyle(hideFollowButton) }, { children: _jsx("button", __assign({ style: getButtonStyle(theme) }, { children: "Follow" })) })), _jsxs("div", __assign({ className: profileNameAndBioContainerStyle }, { children: [_jsx("p", __assign({ className: profileNameStyle }, { children: profile.name || profile.handle })), profile.bio && (_jsx("p", { className: bioStyle, dangerouslySetInnerHTML: {
                                    __html: formatHandleColors(getSubstring(profile.bio))
                                } }))] })), _jsxs("div", __assign({ className: getStatsContainerStyle(theme) }, { children: [_jsxs("p", { children: [profile.stats.totalFollowing.toLocaleString('en-US'), " ", _jsx("span", { children: "Following" })] }), _jsxs("p", { children: [profile.stats.totalFollowers.toLocaleString('en-US'), " ", _jsx("span", { children: "Followers" })] })] })), _jsxs("div", __assign({ className: getFollowedByContainerStyle(theme) }, { children: [_jsx("div", __assign({ className: miniAvatarContainerStyle }, { children: followers.map(function (follower) { return (_jsx("div", __assign({ className: getMiniAvatarWrapper() }, { children: _jsx("img", { src: follower.picture, className: getMiniAvatarStyle(theme) }) }), follower.handle)); }) })), _jsxs("p", { children: [Boolean(followers.length) && _jsx("span", { children: "Followed by" }), formatHandleList(followers.map(function (follower) { return follower.handle; }))] })] }))] }))] })));
}
var profileContainerStyle = {
    borderRadius: '18px',
    overflow: 'hidden',
    cursor: 'pointer'
};
var emptyProfilePictureStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: green;\n  width: 60px;\n  height: 60px;\n  display: flex;\n  left: 0;\n  bottom: -50px;\n  width: 138px;\n  height: 138px;\n  border-radius: 70px;\n  position: absolute;\n  margin-left: 20px;\n  border: 4px solid white;\n"], ["\n  background-color: green;\n  width: 60px;\n  height: 60px;\n  display: flex;\n  left: 0;\n  bottom: -50px;\n  width: 138px;\n  height: 138px;\n  border-radius: 70px;\n  position: absolute;\n  margin-left: 20px;\n  border: 4px solid white;\n"])));
var system = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-family: ", " !important\n"], ["\n  font-family: ", " !important\n"])), systemFonts);
var headerImageContainerStyle = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var profileNameAndBioContainerStyle = css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: 15px;\n"], ["\n  margin-top: 15px;\n"])));
var profileNameStyle = css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: 26px;\n  font-weight: 700;\n  margin: 0;\n"], ["\n  font-size: 26px;\n  font-weight: 700;\n  margin: 0;\n"])));
var bioStyle = css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-weight: 500;\n  margin-top: 9px;\n  margin-bottom: 0;\n  line-height: 24px;\n"], ["\n  font-weight: 500;\n  margin-top: 9px;\n  margin-bottom: 0;\n  line-height: 24px;\n"])));
var profileContainerClass = css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  width: 510px;\n  @media (max-width: 510px) {\n    width: 100%\n  }\n  * {\n    ", ";\n  }\n"], ["\n  width: 510px;\n  @media (max-width: 510px) {\n    width: 100%\n  }\n  * {\n    ", ";\n  }\n"])), system);
var miniAvatarContainerStyle = css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  margin-left: 10px;\n  margin-right: 14px;\n"], ["\n  display: flex;\n  margin-left: 10px;\n  margin-right: 14px;\n"])));
var profilePictureStyle = css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  width: 128px;\n  height: 128px;\n  border-radius: 70px;\n"], ["\n  width: 128px;\n  height: 128px;\n  border-radius: 70px;\n"])));
function getFollowedByContainerStyle(theme) {
    var color = ThemeColor.darkGray;
    if (theme === Theme.dark) {
        color = ThemeColor.white;
    }
    return css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  margin-top: 20px;\n  display: flex;\n  color: ", ";\n  align-items: center;\n  span {\n    opacity: .5;\n    margin-right: 4px;\n  }\n  p {\n    margin-right: 5px;\n    margin-bottom: 0;\n    margin-top: 0;\n    font-weight: 600;\n    font-size: 14px;\n  }\n"], ["\n  margin-top: 20px;\n  display: flex;\n  color: ", ";\n  align-items: center;\n  span {\n    opacity: .5;\n    margin-right: 4px;\n  }\n  p {\n    margin-right: 5px;\n    margin-bottom: 0;\n    margin-top: 0;\n    font-weight: 600;\n    font-size: 14px;\n  }\n"])), color);
}
function getStatsContainerStyle(theme) {
    var color = ThemeColor.darkGray;
    if (theme === Theme.dark) {
        color = ThemeColor.white;
    }
    return css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: flex;\n    margin-top: 15px;\n    * {\n      font-weight: 600;\n    }\n    p {\n      margin-right: 10px;\n      margin-top: 0;\n      margin-bottom: 0;\n    }\n    span {\n      color: ", ";\n      opacity: 50%;\n    }\n    @media (max-width: 510px) {\n      p {\n        margin: 8px 10px 8px 0px;\n      }\n    }\n  "], ["\n    display: flex;\n    margin-top: 15px;\n    * {\n      font-weight: 600;\n    }\n    p {\n      margin-right: 10px;\n      margin-top: 0;\n      margin-bottom: 0;\n    }\n    span {\n      color: ", ";\n      opacity: 50%;\n    }\n    @media (max-width: 510px) {\n      p {\n        margin: 8px 10px 8px 0px;\n      }\n    }\n  "])), color);
}
function getProfileInfoContainerStyle(theme) {
    var backgroundColor = ThemeColor.white;
    var color = ThemeColor.black;
    if (theme === Theme.dark) {
        backgroundColor = ThemeColor.lightBlack;
        color = ThemeColor.white;
    }
    return css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    background-color: ", ";\n    padding: 0px 20px 20px;\n    p {\n      color: ", ";\n    }\n  "], ["\n    background-color: ", ";\n    padding: 0px 20px 20px;\n    p {\n      color: ", ";\n    }\n  "])), backgroundColor, color);
}
function getButtonContainerStyle(hidden) {
    var visibility = hidden ? 'hidden' : 'visible';
    return css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: flex;\n    flex: 1;\n    justify-content: flex-end;\n    visibility: ", ";\n  "], ["\n    display: flex;\n    flex: 1;\n    justify-content: flex-end;\n    visibility: ", ";\n  "])), visibility);
}
function getMiniAvatarWrapper() {
    return css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    margin-left: -10px;\n    borderRadius: 20px;\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    margin-left: -10px;\n    borderRadius: 20px;\n  "])));
}
function getMiniAvatarStyle(theme) {
    var color = ThemeColor.white;
    if (theme === Theme.dark) {
        color = ThemeColor.lightBlack;
    }
    return css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    width: 34px;\n    height: 34px;\n    border-radius: 20px;\n    outline: 2px solid ", ";\n    background-color: ", ";\n  "], ["\n    width: 34px;\n    height: 34px;\n    border-radius: 20px;\n    outline: 2px solid ", ";\n    background-color: ", ";\n  "])), color, color);
}
function getProfilePictureContainerStyle(theme) {
    var backgroundColor = ThemeColor.white;
    if (theme === Theme.dark) {
        backgroundColor = ThemeColor.lightBlack;
    }
    return css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    left: 0;\n    bottom: -50px;\n    background-color: ", ";\n    width: 138px;\n    height: 138px;\n    border-radius: 70px;\n    margin-left: 20px;\n  "], ["\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    left: 0;\n    bottom: -50px;\n    background-color: ", ";\n    width: 138px;\n    height: 138px;\n    border-radius: 70px;\n    margin-left: 20px;\n  "])), backgroundColor);
}
function getHeaderImageStyle(url) {
    var backgroundImage = url ? "url(".concat(url, ")") : 'none';
    return {
        height: '245px',
        backgroundColor: ThemeColor.lightGreen,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: backgroundImage,
        borderTopLeftRadius: '18px',
        borderTopRightRadius: '18px'
    };
}
function getButtonStyle(theme) {
    var backgroundColor = '#3d4b41';
    var color = 'white';
    if (theme === Theme.dark) {
        color = '#191919';
        backgroundColor = '#C3E4CD';
    }
    return {
        marginTop: '10px',
        outline: 'none',
        border: 'none',
        padding: '10px 32px',
        backgroundColor: backgroundColor,
        borderRadius: '50px',
        color: color,
        fontSize: '16px',
        fontWeight: '500',
        cursor: 'pointer'
    };
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;
//# sourceMappingURL=Profile.js.map